
/* Layout */
import Layout from '../views/layout/Layout'
export default {
    path: '/fund',
    component: Layout,
    redirect: '/fund/returnManage',
    name: 'fund',
    meta: {
      title: '资方自服务',
      icon: 'product-list'
    },
    children: [{
        path: 'returnManage',
        name: 'returnManage',
        component: () => import('@/views/fund/returnManage/index'),
        meta: {
          title: '付款管理',
          icon: 'product-list'
        }
      },{
        path: 'fundOrder',
        name: 'fundOrder',
        component: () => import('@/views/fund/fundOrder/index'),
        meta: {
          title: '订单管理',
          icon: 'product-list'
        }
      },{
        path: 'fundAdmin',
        name: 'fundAdmin',
        component: () => import('@/views/fund/fundAdmin/index'),
        meta: {
          title: '账号管理',
          icon: 'product-list'
        }
      },
      //订单tabCom详情页面
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/tabCom/index'),
        meta: {
          title: '订单列表详情',
        },
        hidden: true
      },
    ]
  }


// WEBPACK FOOTER //
// ./src/router/fund.js